module.exports = __webpack_public_path__ + "static/media/integrityIcon.44d5bf78.png";